import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/marketing/SectionHeading";

const CHANNELS = [
  { name: "Journalist Outreach", tagline: "Earned coverage", path: "/services/journalist-outreach" },
  { name: "Newswire Distribution", tagline: "Broad syndication", path: "/services/newswire-distribution" },
  { name: "Guaranteed Placements", tagline: "Named publications", path: "/services/guaranteed-placements" },
];

const ROWS = [
  { label: "What you get", cells: ["Earned editorial coverage", "Broad syndication + Google News", "Publication in named outlets"] },
  { label: "How certain", cells: ["Pitched on merit, not promised", "Guaranteed distribution", "Published or refunded"] },
  { label: "Speed", cells: ["Days to weeks", "Same-day", "A few days"] },
  { label: "Best for", cells: ["Third-party credibility", "Reach, visibility, indexing", "Named outlets and SEO"] },
];

const PRICES = ["From $150", "From $249", "From $100"];

export default function ComparisonTable() {
  return (
    <section className="bg-canvas py-11 lg:py-[72px]">
      <Container className="relative">
        <SectionHeading
          tag="COMPARE"
          title="Three channels, side by side"
          subtitle="Independently purchasable. Combine any of them for broader coverage."
        />

        <div className="overflow-x-auto rounded-[24px] glass-card">
          <table className="w-full min-w-[760px] border-collapse">
            <thead>
              <tr>
                <th className="p-5 text-left align-bottom font-mono text-xs uppercase tracking-widest text-[#6b6880] border-b border-[#e8e6ef] w-40"></th>
                {CHANNELS.map((c) => (
                  <th key={c.path} className="p-5 text-left align-bottom border-b border-l border-[#e8e6ef]">
                    <span className="block text-[#14121c] text-[17px] font-semibold">{c.name}</span>
                    <span className="block text-[#6b6880] text-xs mt-1">{c.tagline}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.label}>
                  <td className="p-5 text-[#6b6880] text-xs uppercase tracking-wider align-top border-b border-[#e8e6ef]">{row.label}</td>
                  {row.cells.map((cell, i) => (
                    <td key={i} className="p-5 text-[#3a3646] text-[15px] leading-[1.6] border-b border-l border-[#e8e6ef] align-top">{cell}</td>
                  ))}
                </tr>
              ))}
              <tr>
                <td className="p-5 text-[#6b6880] text-xs uppercase tracking-wider border-b border-[#e8e6ef]">Starting price</td>
                {PRICES.map((p, i) => (
                  <td key={i} className="p-5 text-[#7200CB] font-semibold text-[15px] border-b border-l border-[#e8e6ef]">{p}</td>
                ))}
              </tr>
              <tr>
                <td className="p-5"></td>
                {CHANNELS.map((c) => (
                  <td key={c.path} className="p-5 border-l border-[#e8e6ef]">
                    <Link to={c.path} className="text-[#7200CB] font-semibold text-[15px] hover:text-[#14121c] transition-colors">Explore →</Link>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </section>
  );
}